import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import base from '@/_api/base';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from '../query-keys';

export function useStagesQuery(festivalId) {
  return useGetQuery(
    () => `/admin/stages/${festivalId}`,
    {},
    queryKeys.stages(festivalId),
    { enabled: festivalId != null && festivalId !== '' },
  );
}

export function usePerformancesQuery(festivalId) {
  return useGetQuery(
    () => `/admin/performances/${festivalId}`,
    {},
    queryKeys.performances(festivalId),
    { enabled: festivalId != null && festivalId !== '' },
  );
}

export function useSaveStageMutation(festivalId) {
  const queryClient = useQueryClient();
  return useApiMutation(
    (stage) => `/admin/stage/${festivalId}`,
    'post',
    {},
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.stages(festivalId),
        });
        NotificationManager.success('Stage saved', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Stage could not be saved', '', 3000);
      },
    },
  );
}

export function useSavePerformanceMutation(festivalId) {
  const queryClient = useQueryClient();
  return useApiMutation(
    (performance) => `/admin/performance/${festivalId}`,
    'post',
    {},
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.performances(festivalId),
        });
        queryClient.invalidateQueries({
          queryKey: queryKeys.stages(festivalId),
        });
        NotificationManager.success('Performance saved', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Performance could not be saved', '', 3000);
      },
    },
  );
}

export function useRemovePerformanceMutation(festivalId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (performanceId) =>
      base.delete(`/admin/performance/${performanceId}`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.performances(festivalId),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.stages(festivalId) });
      NotificationManager.success('Performance removed', '', 3000);
    },
    onError: () => {
      NotificationManager.error('Performance could not be removed', '', 3000);
    },
  });
}
